/* Живая доставка личных настроек, сохранённых продуктом напрямую (напр. «Настройки»
   зовёт PUT /api/prefs, минуя ядро — это её законный прямой путь, products/* не трогаем).
   Ядро не может подписаться на код продукта, поэтому единственная точка, где оно узнаёт
   об изменении без правки продукта, — сам факт успешного запроса к общей ручке; дальше
   используется УЖЕ СУЩЕСТВУЮЩАЯ шина sharedEventBus (та же, что доставляет platform:section
   — см. App.tsx), новый механизм не изобретаем. */
import { sharedEventBus } from "../osnovaContext";
let installed = false;
// Ключ localStorage → ключ personal prefs: решение И-5 — межвкладочная синхронизация одним
// браузерным событием storage на все настройки, без серверного кадра живого канала.
const STORAGE_PREF_KEYS = {
    "osnova-theme": "theme",
    "osnova-locale": "locale",
};
function readBody(body) {
    if (typeof body !== "string")
        return null;
    try {
        const parsed = JSON.parse(body);
        return typeof parsed?.key === "string" ? { key: parsed.key, value: parsed.value } : null;
    }
    catch {
        return null;
    }
}
// installPrefsBridge — ставит перехват один раз за сессию (idempotent), не меняет
// поведение самого запроса, только эмитит "platform:prefs" после успешного PUT.
export function installPrefsBridge() {
    if (installed)
        return;
    installed = true;
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (input, init) => {
        const res = await nativeFetch(input, init);
        const path = typeof input === "string" ? input : input instanceof URL ? input.pathname : input.url;
        if (res.ok && init?.method === "PUT" && path.endsWith("/api/prefs")) {
            const change = readBody(init.body);
            if (change)
                sharedEventBus.emit("platform:prefs", change);
        }
        return res;
    };
    window.addEventListener("storage", (e) => {
        if (e.key === null || e.newValue === null)
            return;
        const prefKey = STORAGE_PREF_KEYS[e.key];
        if (!prefKey)
            return;
        sharedEventBus.emit("platform:prefs", { key: prefKey, value: e.newValue });
    });
}
